<template>
  <div>
    <b-jumbotron
      header="CardxCoin DEX"
      lead="Upload your gift cards and sell them safetly on the blockchain, while earning interest. Purchase from your favorite retailers with cryptocurrency."
    >
      <div>
      </div>
    </b-jumbotron>
    <h1>Instructions</h1>
    There's a few things that will cause vague errors.
        <ol>
          <li>This is on Kovan Testnet, switch your network. No warnings are set up to tell you that you're on the incorrect network.</li>
          <li>Aave requires special Kovan Dai. <a href="https://testnet-v1.aave.com/faucet">There's a faucet here</a></li>
          <li>Not all transactions have loading indicators, sometimes 2 transactions will be prompted one after another, and data is not automatically updated. Wait until metamask shows the transaction as completed. Then wait a little bit longer in case an extra transaction is necessary, then refresh the page</li>
        </ol>

    <!-- <h2>Marketplace</h2>
    <br>
    <div>
      <b-card title="Card Title" no-body>
        <b-card-header header-tag="nav">
          <b-nav card-header tabs>
            <b-nav-item id="buy_tab" :active="active == 0" @click="toggle()">Buy</b-nav-item>
            <b-nav-item id="sell" :active="active == 1" @click="toggle()">Sell</b-nav-item>
          </b-nav>
        </b-card-header>

        <b-card-body class="text-center">
          <buy v-if="this.active == 0"></buy>
          <sell v-if="this.active == 1"></sell>
        </b-card-body>
      </b-card>
    </div> -->
  </div>
</template>
<script>
import Buy from "@/components/marketplace/buy/list.vue";
import Sell from '@/components/marketplace/sell/list.vue';
export default {
  components: {
    Sell,
    Buy,
  },
  data() {
    return {
      tabs: ['buy','sell'],
      active: 1
    }
  },
  methods: {
    toggle(){
      if(this.active == 0) return this.active = 1
      if(this.active == 1) return this.active = 0
    }
  }
};
</script>
<style scoped>
</style>